<template>
  <button class="BackButton d-flex align-items-center" @click="goBack">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" class="mr-1 icon">
      <path fill-rule="evenodd" d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z" clip-rule="evenodd" />
    </svg>
    <span class="back">Terug</span>
  </button>
</template>

<script>

export default {
  methods: {
    goBack() {
      this.$router.back()
    },
  },
}

</script>

<style scoped>

.icon {
  color: rgb(150, 150, 150);
}

.BackButton {
  border: 1px solid var(--black-20) !important;
  color: #000000;
  background-color: white;
  padding: 6px;
  font-weight: 500;
  padding-right: 12px;
  line-height: 16px;
  font-size: 12px;
  border-radius: 1px;
  margin-right: 14px;
}

.BackButton:hover, .BackButton:hover .icon {
  color: var(--primary);
}

.back {
  transform: translateY(1px);
}

</style>
